<template>
    <div class="wrapper">
      <div class="animated fadeIn dashboard-container">
        <!-- FirstMile -->
        <!-- <div > -->
          <b-row>
            <b-col cols="12">
              <b-breadcrumb :items="breadcrumbs" />
              <!-- Code added -->
              <b-card
                header-tag="header"
                footer-tag="footer"
                style="margin-bottom:0px;"
              >
              <!-- :class="{'show--height': pickuplocationmasterid =='' || pickuplocationmasterid=='365', 'notshow--height': pickuplocationmasterid!='365'}" -->
              <!-- style=" margin-bottom: 0px; height:100vh;" -->
              <div v-if="is_superadmin==1" style="display: block;">
                <b-row>
                  <b-col sm="6" >
                    <b-form-group label="Hub Id"  label-size="sm"
                      :label-cols="4" >
                      <!-- {{ selectedHubid }} -->
                      <b-form-select  v-model="selectedHubid" @input="checkHub" >
                        <option value="">--Please Select Hub--</option>
                        <option v-for="hub in hublistData"  v-bind:value="hub.pickuplocationmasterid" >{{hub.pickuplocationname}}</option>
                    </b-form-select> 
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <!-- <b-button variant="primary" class="mr-2" @click="searchvalue()" :disabled="pickuplocationmasterid.length==0">
                      Search
                    </b-button> -->
                    <b-button variant="danger" @click="clearsearch()" :disabled="selectedHubid.length==0"> Clear </b-button>
                  </b-col>
                </b-row>
              </div>
              </b-card>
              <div >
                <!-- v-if="selectedHubid=='' || selectedHubid=='365'" -->
                <!-- {{ userCountry }} -->
              <b-card v-if="selectedHubid=='' || selectedHubid=='365'">
                <label v-if="userCountry != 'KSA'">Overall Firstmile</label>
                <b-row class="boxto" v-if="userCountry != 'KSA'">
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-aqua">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            {{ this.Countriderassing }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Assigned"
                          >
                            Not Attempted:Rider Assigned
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-purpal">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup Not Assigned"
                          >
                            {{ this.Countridernotassing }}
                          </h4>
                          <p
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Overall Not Attempted:Rider Not Assigned"
                          >
                            Not Attempted:Rider Not Assigned
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-def">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            {{ Countriderintransit }}
                          </h4>
                          <p
                            style="padding-bottom: 20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup(INTransit)"
                          >
                            Pickup(INTransit)
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-green">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            {{ Countriderpickcancell }}
                          </h4>
                          <p
                            style="padding-bottom:20px;"
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Pick Cancelled"
                          >
                            Pick Cancelled
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-pink">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Hub Handover Done"
                          >
                            {{ Countriderhandover }}
                          </h4>
                          <p
                            style="padding-bottom:20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Handover To 3PL Hub"
                          >
                            Handover To 3PL Hub
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-card no-body class="bg-yellow">
                      <li>
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="3PL Pickup Not Received Count"
                          >
                            {{ NotAssignedreceived_vendor }}
                          </h4>
                          <p
                            style="padding-bottom:20px;"
                            class="text-center countcolor"
                            v-b-tooltip.hover
                            title="Pickup By 3PL"
                          >
                            Pickup By 3PL &nbsp;&nbsp;&nbsp;&nbsp;
                          </p>
                        </b-card-body>
                      </li>
                    </b-card>
                  </b-col>
                </b-row>

                <label v-if="userCountry != 'KSA'">Firstmile_3PL_Hub_Drop</label>
                <b-row class="boxto" v-if="userCountry != 'KSA'">
                    <b-col sm="6" lg="2">
                      <b-card no-body class="bg-aqua">
                        <li>
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup Assigned"
                            >
                             {{Assigned_Firstmile}}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup Assigned"
                            >
                              Not Attempted:Rider Assigned
                            </p>
                          </b-card-body>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2">
                      <b-card no-body class="bg-purpal">
                        <li>
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup Not Assigned"
                            >
                              {{NotAssigned_Firstmile}}
                            </h4>
                            <p
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Overall Not Attempted:Rider Not Assigned"
                            >
                              Not Attempted:Rider Not Assigned
                            </p>
                          </b-card-body>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2">
                      <b-card no-body class="bg-def">
                        <li>
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup(INTransit)"
                            >
                              {{INTransit_Firstmile}}
                            </h4>
                            <p
                              style="padding-bottom: 20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Pickup(INTransit)"
                            >
                              Pickup(INTransit)
                            </p>
                          </b-card-body>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2">
                      <b-card no-body class="bg-green">
                        <li>
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="Pick Cancelled"
                            >
                             {{Pick_Cancelled_Firstmile}}
                            </h4>
                            <p
                              style="padding-bottom:20px;"
                              class="text-center countcolor "
                              v-b-tooltip.hover
                              title="Pick Cancelled"
                            >
                              Pick Cancelled
                            </p>
                          </b-card-body>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2">
                      <b-card no-body class="bg-pink">
                        <li>
                          <b-card-body class="pb-0">
                            <h4
                              class="mb-0 display-3 text-center countcolor"
                              v-b-tooltip.hover
                              title="3PL Hub Handover Done"
                            >
                              {{Handover_Done_Firstmile}}
                            </h4>
                            <p
                              style="padding-bottom:20px;"
                              class="text-center countcolor"
                              v-b-tooltip.hover
                              title="Handover To 3PL Hub"
                            >
                              Handover To 3PL Hub
                            </p>
                          </b-card-body>
                        </li>
                      </b-card>
                    </b-col>
                </b-row>

                <label v-if="userCountry == 'ME' && (selectedHubid=='' || selectedHubid=='365')">P2P Hub Drop[Vendor to DWC]</label>
                <label v-if="userCountry == 'KSA'"> Overall Firstmile</label>
               
                <b-row class="boxto" style="border-bottom: 2px dotted grey" v-if="selectedHubid=='' || selectedHubid=='365'">

                  <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-purpal">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Pickup_Not_Assigned' + '-' + selectedHubid },
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup Not Assigned"
                            >
                                {{ NotAssigned_vendor }}
                            </h4>
                            <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup Not Assigned"
                            >
                                Not Attempted:Rider Not Assigned
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col>

                    <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-aqua">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Pickup_Assigned' + '-' + selectedHubid },
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup Assigned"
                            >
                                {{ Assigned_vendor }}
                            </h4>
                            <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup Assigned"
                            >
                                Not Attempted:Rider Assigned
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col>

                    <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-def">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Pickup_INTransit' + '-' + selectedHubid},
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup(INTransit)"
                            >
                                {{ INTransit_vendor }}
                            </h4>
                            <p
                                style="padding-bottom: 20px;"
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Pickup(INTransit)"
                            >
                                Pickup(INTransit)
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col>

                    <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-green">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Pick_Cancelled' + '-' + selectedHubid },
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pick Cancelled"
                            >
                                {{ Pick_Cancelled_vendor }}
                            </h4>
                            <p
                                style="padding-bottom: 20px;"
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Pick Cancelled"
                            >
                                Pick Cancelled
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col>

                    <b-col sm="6" lg="2" class="pointer">
                    <b-card no-body class="bg-pink">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Handoverdone_to_P2P_Hub'  + '-' + selectedHubid},
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Handoverdone to P2P Hub"
                            >
                                {{ Handover_Done_vendor }}
                            </h4>
                            <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Handoverdone to P2P Hub"
                            >
                                Handoverdone to P2P Hub
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col>

                    <!-- <b-col
                    sm="6"
                    lg="2"
                    class="pointer">
                    <b-card no-body class="bg-yellow">
                        <li>
                        <router-link
                            tag="li"
                            :to="{
                            name: 'superad_shipmentreport',
                            params: { id: 'Vendor_Pickup_Not_Assigned_Received'  + '-' + selectedHubid},
                            }"
                        >
                            <b-card-body class="pb-0">
                            <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pick By 3PL Not Received"
                            >
                                {{ NotAssignedreceived_vendor }}
                            </h4>
                            <p
                                style="padding-bottom: 20px;"
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="3PL Vendor Pickup Not Assigned"
                            >
                                Pick By 3PL
                            </p>
                            </b-card-body>
                        </router-link>
                        </li>
                    </b-card>
                    </b-col> -->
                </b-row>
              </b-card>
         
              </div>

              <div style="display: none;" id="element">
                <b-row>
                  <b-card  header-tag="header" class="col"
                  footer-tag="footer" >
                    <label>Overall Lastmile</label>
                    <b-row class="boxto">
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-purpal">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Count"
                              >
                                {{ pickcountnotassing }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Shipment Created"
                              >
                                Shipment Created
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Received in HUB Count"
                              >
                                {{ pickcountreceive }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Received in HUB"
                              >
                                Received in HUB
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Count"
                              >
                                {{ pickcountassing}}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Rider Assigned"
                              >
                                Rider Assigned
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
      
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-def">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="OFD Count"
                              >
                                {{ pickcountofd }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="OFD"
                              >
                                OFD
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-pink">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Today's Delivered at Customer Count"
                              >
                                {{ pickcountcustomer }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Today's Delivered at Customer"
                              >
                                Today's Delivered at Customer
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
      
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-red">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="NDR Count"
                              >
                                {{ pickcountndr }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="NDR"
                              >
                                NDR
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="NDR Received Count"
                              >
                                {{ pickcountrto }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="NDR Received"
                              >
                                NDR Received
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-green">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Pick Cancelled(NPR)"
                              >
                                {{ pickcountcamcelledndr }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Pick Cancelled(NPR)"
                              >
                                NPR
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Overall Hub InScan Count"
                              >
                                {{ pickcounthubscan }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Overall Hub InScan Count"
                              >
                                Hub InScan
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                      <!-- <b-col sm="6" lg="2">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Reattempt Count"
                              >
                                {{ pickcountreattempt }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Reattempt"
                              >
                              Reattempt Count
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col> -->
                      <b-col sm="6" lg="2">
                        <b-card no-body class="bg-green">
                          <li>
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Overall RTOSCAN COUNT"
                              >
                                {{ CountLasttmile_Vendor_WH_RTOSCAN_Count }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Overall  RTOSCAN Count"
                              >
                                RTO
                              </p>
                            </b-card-body>
                          </li>
                        </b-card>
                      </b-col>
                          
                    </b-row>
                    <label
                    >Vendor_Lasttmile</label>
                    <b-row
                    class="boxto">
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-purpal">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_Pickup_Not_Assigned'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Shipment Created Count"
                              >
                                {{ Lastmile_Pickup_Not_Assigned }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Shipment Created"
                              >
                                Shipment Created
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>

                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-yellow">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_HubInscan_Count'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Vendor HubInScan Count"
                              >
                                {{ Lastmile_HubInscan }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Vendor HubInScan Count"
                              >
                                Hub Inscan
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>

                    <!-- <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-yellow">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: {
                                id: 'Vendor_Lastmile_Pickup_Not_Assigned_Received' + '-' + selectedHubid
                              },
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Received in HUB Count"
                              >
                                {{ Lastmile_Pickup_Received }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Received in HUB"
                              >
                                Received in HUB
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col> -->
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_Pickup_Assigned' + '-' + selectedHubid },
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Rider Assigned Count"
                              >
                                {{ Lastmile_Pickup_Assigned }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Rider Assigned"
                              >
                                Rider Assigned
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-def">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_Pickup_OFD' + '-' + selectedHubid },
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="OFD Count"
                              >
                                {{ Lastmile_Pickup_OFD }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="OFD"
                              >
                                OFD
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
    
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-pink">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: {
                                id: 'Vendor_Lastmile_Delivered_at_Customer' + '-' + selectedHubid
                              },
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Delivered to Customer"
                              >
                                {{ Lastmile_Delivered_Customer }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Today's Delivered to Customer"
                              >
                                Today's Delivered at Customer
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-red">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_NDR' + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="NDR Count"
                              >
                                {{ Lastmile_NDR }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="NDR (Handoverpending)"
                              >
                                NDR
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_RTOINSCAN'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Received NDR Count"
                              >
                                {{ Lastmile_RTO }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Received NDR"
                              >
                                Received NDR
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
    
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-green">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Lastmile_Pick_Cancelled_NPR'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="NPR Count"
                              >
                                {{ Lastmile_Pick_Cancelled }}
                              </h4>
                              <p
                                class="text-center countcolor "
                                v-b-tooltip.hover
                                title="Pick Cancelled(NPR)"
                              >
                                NPR
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
    
                    <!-- <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'Vendor_Reattempt_Count'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Reattempt Count"
                              >
                                {{ Lastmile_Reattempt_Count }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Reattempt Count"
                              >
                                Reattempt Count
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col> -->
                    <b-col sm="6" lg="2" class="pointer">
                  <b-card no-body class="bg-green">
                    <li>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'superad_shipmentreport',
                          params: { id: 'Vendor_Lastmile_RTO' + '-' + selectedHubid },
                        }"
                      >
                        <b-card-body class="pb-0">
                          <h4
                            class="mb-0 display-3 text-center countcolor"
                            v-b-tooltip.hover
                            title="Final Count"
                          >
                            {{ LastmileVendor_Vendor_Lastmile_RTO }}
                          </h4>
                          <p
                            class="text-center countcolor "
                            v-b-tooltip.hover
                            title="Final Count"
                          >
                            RTO
                          </p>
                        </b-card-body>
                      </router-link>
                    </li>
                  </b-card>
                </b-col>
                    </b-row>
    
                    <label style="padding-top: 10px!important"
                    >WH_Lasttmile</label>
                    <b-row class="boxto"  style="border-bottom: 2px dotted grey ">
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-purpal">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Pickup_Not_Assigned' + '-' + selectedHubid},
                                
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Shipment Created Count"
                                >
                                  {{ WH_Pickup_Not_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Shipment Created"
                                >
                                  Shipment Created
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Pickup_Not_Assigned_Received'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Received in HUB Count"
                                >
                                  {{ WH_Pickup_Not_Assigned_Received }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="Received in HUB"
                                >
                                  Received in HUB
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Pickup_Assigned' + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Rider Assigned Count"
                                >
                                  {{ WH_Pickup_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Rider Assigned"
                                >
                                  Rider Assigned
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col> 
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-def">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Pickup_OFD'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="OFD Count"
                                >
                                  {{ WH_Pickup_OFD }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="OFD"
                                >
                                  OFD
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-pink">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Delivered_at_Customer'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Today's Delivered at Customer"
                                >
                                  {{ WH_Delivered_at_Customer }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Today's Delivered at Customer"
                                >
                                  Today's Delivered at Customer
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-red">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_NDR'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="NDR Count"
                                >
                                  {{ WH_NDR }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="NDR (Handoverpending)"
                                >
                                  NDR
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_RTOINSCAN'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Received NDR Count"
                                >
                                  {{ WH_RTO }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="Received NDR"
                                >
                                  Received NDR
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-green">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Pick_Cancelled_NPR'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="NPR Count"
                                >
                                  {{ WH_Pick_Cancelled_NPR }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="Pick Cancelled(NPR)"
                                >
                                  NPR
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_HubInscan_Count'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="WH HubInscan Count"
                                >
                                  {{ WH_HubInscan_Count }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="WH HubInscan Count"
                                >
                                  Hub Inscan
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <!-- <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_Reattempt_Count'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Return To Origin Count"
                                >
                                  {{ WH_Reattempt_Count }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="WH Reattempt Count"
                                >
                                Reattempt Count
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col> -->
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-green">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'WH_RTO' + '-' + selectedHubid },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Final Count"
                                >
                                  {{ LasttmileWH_RTOScan }}
                                </h4>
                                <p
                                  class="text-center countcolor "
                                  v-b-tooltip.hover
                                  title="Final Count"
                                >
                                  RTO
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                    </b-row>
    
                    <label style="padding-top: 10px!important"
                    >Reverse Count</label>
                    <b-row
                      class="boxto"
                      style="border-bottom: 2px dotted grey "
                    >
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-purpal">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_pickup_Not_Assigned'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Shipment Created Count"
                                >
                                  {{ Reverse_pickup_Not_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Shipment Created"
                                >
                                  RVP Created Shipment
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col
                        sm="6"
                        lg="2"
                        class="pointer"
                      >
                        <b-card no-body class="bg-yellow">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: {
                                  id: 'Reverse_pickup_Not_Assigned_Received' + '-' + selectedHubid
                                },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center"
                                  v-b-tooltip.hover
                                  title="Received in HUB Count"
                                >
                                  {{ Reverse_pickup_Not_Assigned_Received }}
                                </h4>
                                <p
                                  class="text-center "
                                  v-b-tooltip.hover
                                  title="Received in HUB"
                                >
                                  Received in HUB
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_Pickup_Assigned'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Rider Assigned Count"
                                >
                                  {{ Reverse_Pickup_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Rider Assigned"
                                >
                                  Rider Assigned
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-def">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_Picked_UP'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="RVP picked Up Count"
                                >
                                  {{ Reverse_Picked_UP }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="RVP picked Up"
                                >
                                RVP picked Up
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-pink">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_RTO'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center"
                                  v-b-tooltip.hover
                                  title="NDR Received Count"
                                >
                                  {{ Reverse_RTO }}
                                </h4>
                                <p
                                  class="text-center "
                                  v-b-tooltip.hover
                                  title="NDR Received"
                                >
                                  NDR Received
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-green">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_NPR'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="NPR Count"
                                >
                                  {{ Reverse_NPR }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="NPR"
                                >
                                  NPR
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>

                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_ClientPickCancel'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="ClientPickCancel Count"
                                >
                                  {{ Reverse_ClientPickCancel }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Client Pick Cancel"
                                >
                                  Client Pick Cancel 
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>

                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-red">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: { id: 'Reverse_PickupPending'  + '-' + selectedHubid},
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="More Than 3 Days Pickup Pending Count"
                                >
                                  {{ Reverse_PickupPending }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="More Than 3 Days Pickup Pending"
                                >
                                  More Than 3 Days Pickup Pending
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                    </b-row>
    
                    <label v-if="selectedHubid=='' || selectedHubid=='365'">Cross Country Shipments [Vendor to WH]</label
                    >
                    <b-row
                      class="boxto" v-if="selectedHubid=='' || selectedHubid=='365'">
                      <b-col sm="6" lg="2" class="pointer" >
                        <b-card no-body class="bg-aqua">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'crosscountrysuperad_shipmentreport',
                                params: {
                                  id: 'Vendor_CrossCountry_Pickup_Not_Assigned' + '-' + selectedHubid
                                },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup Not Assigned Count"
                                >
                                  {{ CrossCountry_Pickup_Not_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup Not Assigned"
                                >
                                  Booking Pending
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-purpal">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'crosscountrysuperad_shipmentreport',
                                params: {
                                  id: 'Vendor_CrossCountry_Pickup_Assigned' + '-' + selectedHubid
                                },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup Assigned Count"
                                >
                                  {{ CrossCountry_Pickup_Assigned }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup Assigned"
                                >
                                  Booking Done
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
    
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                                name: 'crosscountrysuperad_shipmentreport',
                                params: {
                                  id: 'Vendor_CrossCountry_Pickup_INTransit' + '-' + selectedHubid
                                },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup INTransit Count"
                                >
                                  {{ CrossCountry_Pickup_INTransit }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="Vendor CrossCountry Pickup INTransit"
                                >
                                  INTransit
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                    </b-row>
                    
    
                    <label style="padding-top: 10px!important" v-if="selectedHubid=='' || selectedHubid=='365'">Cross Country Shipments [WH to SkyEx]</label
                  >
                  <b-row
                    class="boxto" v-if="selectedHubid=='' || selectedHubid=='365'">
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-aqua">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'crosscountrysuperad_shipmentreport',
                              params: {
                                id: 'WH_CrossCountry_Pickup_Not_Assigned' + '-' + selectedHubid
                              },
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Forward Warrenty pickup Assigned Count"
                              >
                                {{ WH_CrossCountry_Pickup_Not_Assigned }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title=" Booking Pending"
                              >
                                Booking Pending
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-purpal">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'crosscountrysuperad_shipmentreport',
                              params: { id: 'WH_CrossCountry_Pickup_Assigned'  + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="Booking Done"
                              >
                                {{ WH_CrossCountry_Pickup_Assigned }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="Booking Done"
                              >
                                Booking Done
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
    
                    <b-col sm="6" lg="2" class="pointer">
                      <b-card no-body class="bg-yellow">
                        <li>
                          <router-link
                            tag="li"
                            :to="{
                              name: 'crosscountrysuperad_shipmentreport',
                              params: { id: 'WH_CrossCountry_Pickup_INTransit' + '-' + selectedHubid},
                            }"
                          >
                            <b-card-body class="pb-0">
                              <h4
                                class="mb-0 display-3 text-center countcolor"
                                v-b-tooltip.hover
                                title="INTransit"
                              >
                                {{ WH_CrossCountry_Pickup_INTransit }}
                              </h4>
                              <p
                                class="text-center countcolor"
                                v-b-tooltip.hover
                                title="INTransit"
                              >
                                INTransit
                              </p>
                            </b-card-body>
                          </router-link>
                        </li>
                      </b-card>
                    </b-col>
                  </b-row>

                  <div v-if="selectedHubid==365 || selectedHubid ==''">
                    <label v-if="userCountry == 'KSA'" style="padding-top: 10px!important">Hub To Hub</label>
                    <b-row class="boxto" style="border-bottom: 2px dotted grey " v-if="userCountry == 'KSA'">
                      <b-col sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-purpal">
                          <li>
                            <router-link
                              tag="li"
                              :to="{
                              name: 'superad_shipmentreport',
                              params: { id: 'WH_Pickup_Assigned_Hub_To_Hub' + '-' + selectedHubid},
                            }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center countcolor"
                                  v-b-tooltip.hover
                                  title="HubToHub BookingDone Count"
                                >
                                {{ HubtoHubBookingDone }}
                                </h4>
                                <p
                                  class="text-center countcolor"
                                  v-b-tooltip.hover
                                  title="HubToHub BookingDone"
                                >
                                  HubToHub BookingDone
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>

                      <b-col  sm="6" lg="2" class="pointer">
                        <b-card no-body class="bg-yellow">
                          <li>
                            <router-link tag="li"
                              :to="{
                                name: 'superad_shipmentreport',
                                params: {
                                  id: 'WH_Pickup_Assigned_Hub_Intransit' + '-' + selectedHubid
                                },
                              }"
                            >
                              <b-card-body class="pb-0">
                                <h4
                                  class="mb-0 display-3 text-center"
                                  v-b-tooltip.hover
                                  title="HubToHub INTransit Count"
                                >
                                  <!-- {{ Reversepickupnotassigned }} -->
                                  {{ hubtohubIntransit }}
                                </h4>
                                <p class="text-center " v-b-tooltip.hover title="HubToHub INTransit">
                                  HubToHub INTransit
                                </p>
                              </b-card-body>
                            </router-link>
                          </li>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                  </b-card>
                </b-row>
              </div>
         
            </b-col>
          </b-row>
        <!-- </div> -->
      </div>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  // import { useRouter } from 'vue-router';
  // const router = useRouter();
  
  export default {
    name: "dashboard_new",
    data: function() {
      return {
        hublistData:[],
        selectedHubid : '',
        userCountry :'',
        is_superadmin : '',
        firstmilecount : [],
        Handover_Done_Firstmile : 0,
        Pick_Cancelled_Firstmile : 0,
        Assigned_Firstmile : 0,
        INTransit_Firstmile : 0,
        NotAssigned_Firstmile : 0,
        //
        Handover_Done_vendor : 0,
        Pick_Cancelled_vendor : 0,
        Assigned_vendor : 0,
        INTransit_vendor : 0,
        NotAssigned_vendor : 0,
        NotAssignedreceived_vendor : 0,
        ////////////////////////////////////////////
        // totalcount
        Countriderassing : 0,
        Countridernotassing : 0,
        Countriderintransit : 0,
        Countriderpickcancell : 0,
        Countriderhandover : 0,
        //LastMilecount
        Lasttmilecount : [],
        Lastmile_Delivered_Customer : 0,
        Lastmile_NDR : 0,
        Lastmile_Pick_Cancelled : 0,
        Lastmile_Pickup_Assigned : 0,
        Lastmile_HubInscan : 0,
        Lastmile_Pickup_Not_Assigned : 0,
        Lastmile_Pickup_Received : 0,
        Lastmile_Pickup_OFD : 0,
        Lastmile_RTO : 0,
        Lastmile_Reattempt_Count : 0,
        LastmileVendor_Vendor_Lastmile_RTO:0,
        //
        WH_Delivered_at_Customer : 0,
        WH_HubInscan_Count : 0,
        WH_NDR : 0,
        WH_Pick_Cancelled_NPR : 0,
        WH_Pickup_Assigned : 0,
        WH_Pickup_Not_Assigned : 0,
        WH_Pickup_Not_Assigned_Received : 0,
        WH_Pickup_OFD : 0,
        WH_RTO : 0,
        WH_Reattempt_Count : 0,
        LasttmileWH_RTOScan:0,


        /////////////////////////////////////////////
        //total count 
        pickcountnotassing : 0,
        pickcountnotassing : 0,
        pickcountreceive : 0,
        pickcountassing : 0,
        pickcountofd : 0, 
        pickcountcustomer : 0, 
        pickcountndr : 0,
        pickcountrto : 0,
        pickcounthubscan : 0,
        pickcountreattempt : 0,
        CountLasttmile_Vendor_WH_RTOSCAN_Count:0,
        // Reverse count
        Reversecount : [],
        Reverse_NPR : 0,
        Reverse_Picked_UP : 0,
        Reverse_Pickup_Assigned : 0,
        Reverse_RTO : 0,
        Reverse_pickup_Not_Assigned : 0,
        Reverse_pickup_Not_Assigned_Received : 0,
        Reverse_ClientPickCancel : 0,
        Reverse_PickupPending : 0,

        //crosscountry count
        CrossCountry_Pickup_Assigned : 0,
        CrossCountry_Pickup_INTransit : 0,
        CrossCountry_Pickup_Not_Assigned : 0,
        //
        WH_CrossCountry_Pickup_Assigned : 0,
        WH_CrossCountry_Pickup_INTransit : 0,
        WH_CrossCountry_Pickup_Not_Assigned : 0,

        hubtohubIntransit:0,
        HubtoHubBookingDone:0,


        breadcrumbs: [
            {
            text: "Dashboard",
            active: true,
            },
        ],
        scrolled: false,
      };
    },
    
    created() {
        // this.selectedHubid = this.$route.params.id || '';
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.userCountry = userInfo.country;
        this.is_superadmin = userInfo.is_superadmin
        console.log("Country",userInfo);
        console.log("this.this.selectedHubid",localStorage.getItem("SelectHub"));
        this.selectedHubid = localStorage.getItem("SelectHub")!='' ? JSON.parse(localStorage.getItem("SelectHub")):'';
        // console.log("this.this.selectedHubid",this.selectedHubid);
        // console.log("@@@@@@@@@@this.selectedHubid",this.selectedHubid);
        window.addEventListener("scroll", this.scroll);
      
        
        // this.CountLastmileKSA();
        // this.CountReversemileKSA();
        // this.CountCrossCountryShipment();
        
    },
  //   watch: {
  //     selectedHubid(newValue) {
  //       console.log("NewValueeeeee",newValue);
  //       // this.selectedHubid=newValue
  //     // this.$router.replace(`/superadmin_dashboard/${newValue}`);
  //   }
  //  },
    destroyed() {
      // alert("innn");
      // localStorage.setItem('SelectHub', '')
      window.removeEventListener("scroll", this.scroll);
    },

    mounted() {
      this.gethublist();
      this.CountFirstmileKSA();
      this.lazyloadingcall();
       if(this.selectedHubid !='365'){
          document.getElementById("element").style.display = "block";
            // this.CountFirstmileKSA();
            this.CountLastmileKSA();
            this.CountReversemileKSA();
            this.CountCrossCountryShipment();
        }
    },

    methods: {

      lazyloadingcall: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // this.pickuplocationmasterid = userInfo.pickuplocationmasterid;
          // if (this.pickuplocationmasterid == 365) {
            // alert("i m in if")
            this.scroll();
          // } 
        // }
      },

      scroll: function() {

      // alert("inn");
      // window.onscroll = () => {
      if ((this.scrolled = window.scrollY > 0)) {
        // console.log("ttttttt",window.scrollY);
        let ZoomCheck = Math.round(
          (window.outerWidth / window.innerWidth) * 100
        );
        // console.log("ZoomCheck", ZoomCheck);
        let bottomOfWindow =
          ZoomCheck == 100
            ? document.documentElement.scrollTop + window.innerHeight ===
              document.documentElement.offsetHeight
            : ZoomCheck <= 67
            ? (document.documentElement.scrollTop + window.innerHeight ===
                document.documentElement.offsetHeight) +
              2
            : Math.round(
                document.documentElement.scrollTop + window.innerHeight
              ) +
                1 ===
              document.documentElement.offsetHeight;

        // console.log(
        //   "scrollTop",
        //   Math.round(document.documentElement.scrollTop + window.innerHeight) +
        //     1
        // );
        // console.log("offsetHeight", document.documentElement.offsetHeight);
        // console.log("window", bottomOfWindow);

        if (bottomOfWindow) {
          // console.log("nnnnnnnnnn",this.scrolled);
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          // alert(userInfo.pickuplocationmasterid);
          document.getElementById("element").style.display = "block";
          this.CountLastmileKSA();
        this.CountReversemileKSA();
        this.CountCrossCountryShipment();

        }
      }
    },
        CountFirstmileKSA : function(){
            // alert("ok")
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj={
              serviceid : this.selectedHubid
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardShipmentHubWiseCountFirstmileKSA`, obj).then((result) => {
              document.getElementById("overlay").style.display = "none";
            console.log("result",result)
            this.firstmilecount = result.body.returnvalue;
            console.log("firstmilecount",this.firstmilecount)

            this.Handover_Done_Firstmile = result.body.returnvalue.Firstmile
            .Firstmile_3PL_Hub_Drop.PL_Hub_Handover_Done; 
            this.Pick_Cancelled_Firstmile = result.body.returnvalue.Firstmile
            .Firstmile_3PL_Hub_Drop.PL_Pick_Cancelled;   
            this.Assigned_Firstmile = result.body.returnvalue.Firstmile
            .Firstmile_3PL_Hub_Drop.PL_Pickup_Assigned; 
            this.INTransit_Firstmile = result.body.returnvalue.Firstmile
            .Firstmile_3PL_Hub_Drop.PL_Pickup_INTransit; 
            this.NotAssigned_Firstmile = result.body.returnvalue.Firstmile
            .Firstmile_3PL_Hub_Drop.PL_Pickup_Not_Assigned; 

                //P2P Hub Drop count
            this.Handover_Done_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Handoverdone_to_P2P_Hub; 
            this.Pick_Cancelled_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Pick_Cancelled;   
            this.Assigned_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Pickup_Assigned; 
            this.INTransit_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Pickup_INTransit; 
            this.NotAssigned_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Pickup_Not_Assigned; 
            this.NotAssignedreceived_vendor = result.body.returnvalue.Firstmile
            .P2P_Hub_Drop.Vendor_Pickup_Not_Assigned_Received; 

            //total count 
            this.Countriderassing = parseInt(this.Assigned_Firstmile) + parseInt(this.Assigned_vendor);
            this.Countridernotassing = parseInt(this.NotAssigned_Firstmile) + parseInt(this.NotAssigned_vendor);
            this.Countriderintransit = parseInt(this.INTransit_Firstmile) + parseInt(this.INTransit_vendor);
            this.Countriderpickcancell = parseInt(this.Pick_Cancelled_Firstmile) + parseInt(this.Pick_Cancelled_vendor);
            this.Countriderhandover = parseInt(this.Handover_Done_Firstmile) + parseInt(this.Handover_Done_vendor);
          })
          .catch((ex) => {
            console.log('error-----', ex)
          })
        },

        CountLastmileKSA : function(){
            // alert("ok")
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj={
              serviceid : this.selectedHubid
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardShipmentHubWiseCountLastmileKSA`, obj).then((result) => {
              document.getElementById("overlay").style.display = "none";
            console.log("result",result)
            this.Lasttmilecount = result.body.returnvalue;
            console.log("Lasttmile",this.Lasttmilecount)

            this.Lastmile_Delivered_Customer = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Delivered_at_Customer; 
          
            this.Lastmile_NDR = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_NDR
            console.log("Lastmile_NDR", this.Lastmile_NDR);
            this.Lastmile_Pick_Cancelled = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Pick_Cancelled_NPR;   

            this.Lastmile_Pickup_Assigned = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Pickup_Assigned; 

            this.Lastmile_HubInscan = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_HubInscan_Count; 

            this.Lastmile_Pickup_Not_Assigned = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned;
            
            this.Lastmile_Pickup_Received = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Pickup_Not_Assigned_Received;

            this.Lastmile_Pickup_OFD = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Pickup_OFD;

            this.Lastmile_RTO = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_RTOINSCAN;

            this.Lastmile_Reattempt_Count = result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_Reattempt_Count;
            this.LastmileVendor_Vendor_Lastmile_RTO=result.body.returnvalue.Lasttmile
            .Vendor_Lasttmile.Vendor_Lastmile_RTO;

                //WH_Lasttmile count
            this.WH_Delivered_at_Customer = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Delivered_at_Customer; 

            this.WH_HubInscan_Count = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_HubInscan_Count;   

            this.WH_NDR = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_NDR; 
            console.log("WH_NDR", this.WH_NDR);
            this.WH_Pick_Cancelled_NPR = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Pick_Cancelled_NPR; 

            this.WH_Pickup_Assigned = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Pickup_Assigned; 

            this.WH_Pickup_Not_Assigned = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Pickup_Not_Assigned; 

            this.WH_Pickup_Not_Assigned_Received = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Pickup_Not_Assigned_Received; 

            this.WH_Pickup_OFD = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Pickup_OFD; 

            this.WH_RTO = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_RTOINSCAN; 

            this.WH_Reattempt_Count = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_Reattempt_Count; 

            this.LasttmileWH_RTOScan = result.body.returnvalue.Lasttmile
            .WH_Lasttmile.WH_RTO; 

               this.HubtoHubBookingDone=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_To_Hub;
                this.hubtohubIntransit=result.body.returnvalue.Lasttmile.WH_Lasttmile.WH_Pickup_Assigned_Hub_Intransit;
             //total count 
             this.pickcountnotassing = parseInt(this.Lastmile_Pickup_Not_Assigned) + parseInt(this.WH_Pickup_Not_Assigned);
             
            this.pickcountreceive = parseInt(this.Lastmile_Pickup_Received) + parseInt(this.WH_Pickup_Not_Assigned_Received);

            this.pickcountassing = parseInt(this.Lastmile_Pickup_Assigned) + parseInt(this.WH_Pickup_Assigned);

            this.pickcountofd = parseInt(this.Lastmile_Pickup_OFD) + parseInt(this.WH_Pickup_OFD);

            this.pickcountcustomer = parseInt(this.Lastmile_Delivered_Customer) + parseInt(this.WH_Delivered_at_Customer);

            this.pickcountndr = parseInt(this.Lastmile_NDR) + parseInt(this.WH_NDR);
            console.log("PICKKKKKKKKKKKK",this.pickcountndr);

            this.pickcountrto = parseInt(this.Lastmile_RTO) + parseInt(this.WH_RTO);
            this.pickcountcamcelledndr = parseInt(this.Lastmile_Pick_Cancelled) + parseInt(this.WH_Pick_Cancelled_NPR);

            this.pickcounthubscan = parseInt(this.Lastmile_HubInscan) + parseInt(this.WH_HubInscan_Count);

            this.pickcountreattempt = parseInt(this.Lastmile_Reattempt_Count) + parseInt(this.WH_Reattempt_Count);

            this.CountLasttmile_Vendor_WH_RTOSCAN_Count=parseInt(this.LasttmileWH_RTOScan) + parseInt(this.LastmileVendor_Vendor_Lastmile_RTO);
          })
          .catch((ex) => {
            console.log('error-----', ex)
          })

        },

        CountReversemileKSA : function(){
            // alert("ok")
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj={
              serviceid : this.selectedHubid
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardShipmentHubWiseCountReverseKSA`, obj).then((result) => {
            console.log("result",result)
            this.Reversecount = result.body.returnvalue;
            console.log("Reversecount",this.Reversecount)

            this.Reverse_NPR = result.body.returnvalue.Reverse
            .Reverse_NPR; 

            this.Reverse_Picked_UP = result.body.returnvalue.Reverse
            .Reverse_Picked_UP

            this.Reverse_Pickup_Assigned = result.body.returnvalue.Reverse
            .Reverse_Pickup_Assigned;   

            this.Reverse_RTO = result.body.returnvalue.Reverse
            .Reverse_RTO; 

            this.Reverse_pickup_Not_Assigned = result.body.returnvalue.Reverse
            .Reverse_pickup_Not_Assigned; 

            this.Reverse_pickup_Not_Assigned_Received = result.body.returnvalue.Reverse
            .Reverse_pickup_Not_Assigned_Received;

            this.Reverse_ClientPickCancel = result.body.returnvalue.Reverse
            .Reverse_ClientPickCancel ? result.body.returnvalue.Reverse
            .Reverse_ClientPickCancel : 0;

            this.Reverse_PickupPending = result.body.returnvalue.Reverse
            .Reverse_PickupPending ? result.body.returnvalue.Reverse
            .Reverse_PickupPending : 0;
          })
          .catch((ex) => {
            console.log('error-----', ex)
          })

        },

        CountCrossCountryShipment : function(){
            // alert("ok")
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj={
                serviceid : this.selectedHubid
            }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardCrossCountryHubWiseShipmentCountKSA`, obj).then((result) => {
            console.log("result",result)
            this.crosscountrycount = result.body.returnvalue;
            console.log("crosscountrycount",this.crosscountrycount)

            this.CrossCountry_Pickup_Assigned = result.body.returnvalue.CrossCountryFirstmile.Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_Assigned; 

            this.CrossCountry_Pickup_INTransit = result.body.returnvalue.CrossCountryFirstmile.Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_INTransit

            this.CrossCountry_Pickup_Not_Assigned = result.body.returnvalue.CrossCountryFirstmile
            .Vendor_CrossCountry_Firstmile.Vendor_CrossCountry_Pickup_Not_Assigned

            //

            this.WH_CrossCountry_Pickup_Assigned = result.body.returnvalue.CrossCountryFirstmile.WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_Assigned; 

            this.WH_CrossCountry_Pickup_INTransit = result.body.returnvalue.CrossCountryFirstmile.WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_INTransit

            this.WH_CrossCountry_Pickup_Not_Assigned = result.body.returnvalue.CrossCountryFirstmile
            .WH_CrossCountry_Lastmile.WH_CrossCountry_Pickup_Not_Assigned

          })
          .catch((ex) => {
            console.log('error-----', ex)
          })

        },

        gethublist: function(){
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
        
          const obj = {
            hub_id:`${userInfo.pickuplocationmasterid}`,
          
          };
        
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
            .then(result => {
              
              if(result.body.returnmsg=='Successful'){
              this.hublistData = result.body.returnvalue;
            
              }
              
            })
            .catch(ex => {
              alert('error-----',ex);
            });
        }, 

        // searchvalue: function(){
        //   this.CountFirstmileKSA();
        //   this.CountLastmileKSA();
        //   this.CountReversemileKSA();
        //   this.CountCrossCountryShipment();
        // },

        clearsearch: function(){
          this.selectedHubid = "";
          this.CountFirstmileKSA();
          this.CountLastmileKSA();
          this.CountReversemileKSA();
          this.CountCrossCountryShipment();
        },
        checkHub(){
          // if(this.pickuplocationmasterid == '365'){
            if(this.selectedHubid != '365'){
              document.getElementById("element").style.display = "block";
            }
            console.log("VVVVVVV",this.selectedHubid)
            let selectedHub=this.selectedHubid
             localStorage.setItem('SelectHub',selectedHub);
            //  console.log("TESTTTTT",localStorage.setItem('SelectHub',this.selectedHubid));
            this.CountFirstmileKSA();
            this.CountLastmileKSA();
            this.CountReversemileKSA();
            this.CountCrossCountryShipment();
          // }
        }
    },
   
  };
  </script>
  
  <style>
  .dashboard-container li{
    height: 105px !important;
  }

  .dashboard-container .display-3 {
    font-size: 3rem !important;
  }

  .bg-aqua {
    background-color: #00c0ef !important;
    color: #fff !important;
  }
  .bg-green {
    background-color: #00a65a !important;
    color: #fff !important;
  }
  .bg-yellow {
    background-color: #f39c12 !important;
    color: #fff !important;
  }
  .bg-pink {
    background-color: #ff69b4 !important;
    color: #fff !important;
  }
  .bg-purpal {
    background-color: #9370db !important;
    color: #fff !important;
  }
  .bg-cyan {
    background-color: #008b8b !important;
    color: #fff !important;
  }
  .bg-red {
    background-color: #dd4b39 !important;
    color: #fff !important;
  }
  .bg-def {
    background-color: #f09642 !important;
    color: #fff !important;
  }
  .boxto .card-body {
    padding: 0px !important;
  }
  .heading {
    padding: 12px 12px 5px 12px !important;
  }
  .countcolor {
    color: white !important;
  }
  .pointer {
    cursor: pointer !important;
  }
  </style>
  